module.exports = angular.module(__filename, []).service('authPropagationGuard', [
  '$q',
  '$timeout',
  '$rootScope',
  function ($q, $timeout, $rootScope) {
    // Deduplicate concurrent retry flows by key
    const inflight = new Map();

    function sleep(ms) {
      return $q((resolve) => $timeout(resolve, ms));
    }

    function isRetryableAuthPropagationError(err, opts) {
      if (!err) return false;
      const status = typeof err.status === 'number' ? err.status : undefined;
      const isForbidden = status === 403;
      const isTransientNetwork = status === -1 || status === 0;
      if (!(isForbidden || isTransientNetwork)) return false;
      const method = (err.config && err.config.method) || '';
      if (String(method).toUpperCase() !== 'GET') return false;
      const now = Date.now();
      const graceMs = typeof opts.graceMs === 'number' ? opts.graceMs : 30000;
      const ctx = $rootScope.context || {};
      const changedWithinWindow = ctx.lastProgramChangedAt && now - ctx.lastProgramChangedAt < graceMs;
      return !!changedWithinWindow;
    }

    async function attemptWithBackoff(requestFn, opts) {
      const started = Date.now();
      const maxMs = typeof opts.maxMs === 'number' ? opts.maxMs : 30000;
      let delay = typeof opts.initialDelay === 'number' ? opts.initialDelay : 200;
      const factor = typeof opts.backoffFactor === 'number' ? opts.backoffFactor : 2;
      const maxDelay = typeof opts.maxDelay === 'number' ? opts.maxDelay : 3500;

      // First attempt immediately
      // Loop until success or timeout
      // eslint-disable-next-line no-constant-condition
      while (true) {
        try {
          // requestFn returns an $http promise-like; await works with thenables
          const res = await requestFn();
          return res;
        } catch (err) {
          if (!isRetryableAuthPropagationError(err, opts)) throw err;
          const elapsed = Date.now() - started;
          if (elapsed >= maxMs) {
            // Attach a hint for callers/UI if needed
            err.transientAuthTimeout = true;
            throw err;
          }
          const jitter = Math.floor(Math.random() * 100);
          const toWait = Math.min(delay + jitter, maxMs - elapsed);
          await sleep(toWait);
          delay = Math.min(delay * factor, maxDelay);
        }
      }
    }

    function getWithAuthRetry(requestFn, opts = {}) {
      const key = opts.key || 'default';
      if (inflight.has(key)) return inflight.get(key);
      const p = (async () => {
        try {
          return await attemptWithBackoff(requestFn, opts);
        } finally {
          inflight.delete(key);
        }
      })();
      inflight.set(key, p);
      return p;
    }

    return {
      getWithAuthRetry,
    };
  },
]);
